import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import { mergeWith } from 'lodash';
export var recursiveMerge = function recursiveMerge(objValue, srcValue) {
  return mergeWith(objValue, srcValue, function (objVal, srcVal) {
    if (Array.isArray(objVal) && Array.isArray(srcVal)) {
      // If the array contains only primitives, just concatenate
      if (objVal.every(function (item) {
        return _typeof(item) !== 'object' || item === null;
      })) {
        return _toConsumableArray(srcVal);
      }
      // For arrays of objects, use recursive merge
      return srcVal.map(function (v, i) {
        return i < objVal.length ? recursiveMerge(objVal[i], v) : v;
      }).concat(objVal.slice(srcVal.length));
    }
    // Return undefined to let Lodash handle the merge for non-array values
    return undefined;
  });
};